<template>
	<div class="orderinport">
		<el-form :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-row>
				<el-col :span="24">
					<el-card class="box-card" label="选择文件" style="text-align: center;">
						<div slot="header" class="clearfix" style="text-align: left;">
							<span>选择文件</span>
							<a :href="downpath">(导入模板)</a>
						</div>
						<el-upload
							name="fileupload"
							drag
							:action="fileurl"
							:multiple="false"
							:limit="1"
							accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
							auto-upload
							:on-success="UploadSuccess"
							:on-error="UploadError"
							:on-change="UploadChange"
							:show-file-list="false"
							ref="upload"
							:file-list="filelist"
						>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
								<br />
								( 支持 .xlsx .xls 文件 )
							</div>
						</el-upload>
						<div style="width:100%;text-align:center;">{{ filename }}</div>
					</el-card>
				</el-col>
				<el-col :span="24"><senderaddr ref="senderaddr" title="寄件信息" l_mode="寄件人信息-出口" v-if="isshowaddr"></senderaddr></el-col>
			</el-row>
		</el-form>
		<el-row v-if="fileurl != ''" class="footerhandler" style="margin-left:-30px">
			<el-col :span="13" class="submitBtn">
				<div @click="GetImportFee">获取报价</div>
			</el-col>
		</el-row>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import senderaddr from '@/components/address/senderaddr_ssq.vue';
import exportwin from '@/components/order/exportwin.vue';
export default {
	components: {
		senderaddr,
		exportwin
	},
	props: {},
	data() {
		return {
			windowHeight: window.innerHeight - 250,
			downpath: localStorage.getItem('c_folder') + '/导入模版.zip', //导入模板路径
			fileurl:'',
			filename:'',
			filelist:[],
			isshowaddr:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/orderinport.scss');
		});
	},
	methods:{
		init(){
			var that=this;
			that.fileurl =
				that.$apiprototype.ApiServer + '/Order/checkexcelfile?domain=' + that.$apiprototype.WebServer + '&mode=报价&l_mode=报价&userid='+localStorage.getItem('userid');
		},
		UploadSuccess(res, file, fileList) {
			var that=this;
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.uploadfileurl = res.fileurl;
				this.filename = res.filename;
				this.tid = res.tid;
				this.isshowaddr = res.isaddr === 'true' ? true : false;
				if(this.isshowaddr){
					this.$nextTick(function() {
						that.$refs.senderaddr.init({ syscol: res.syscol, orderinfo: {}, isznsplit: true });
					});
				}
			} else {
				this.filename = '';
				this.$tool.message(res.message, 0);
			}
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			if(fileList.length>0)
				this.$tool.loading('正在检测文件', 'orderinport');
		},
		checkorderdata(inportinfo){
			var sender = '',error='';
			if(this.$refs.senderaddr!=undefined)
			{
				var setlist = this.$refs.senderaddr._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.senderaddr.title + '-' + e.showname;
							sender = '';
						} else {
							if (error == '') {
								if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!that.$tool.checkidcardformat(e.value)) {
										error = that.$refs.senderaddr.title + '-' + e.showname + '格式不正确';
										sender = '';
									}
								}
							}
						}
						if (error == '') sender += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (error == '') {
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							inportinfo.sender = JSON.parse(sender);
						}
					}
				}
			}
			return inportinfo;
		},
		checkdata(inportinfo) {
			var error = '';
			if (this.uploadfileurl == '' || this.uploadfileurl == undefined) {
				error = '请上传文件';
			} else {
				inportinfo = this.checkorderdata(inportinfo);
				inportinfo.fileurl = this.uploadfileurl;
				inportinfo.tid = this.tid;
				inportinfo.u_userid = localStorage.getItem('userid');
				inportinfo.u_name = localStorage.getItem('u_name');
				inportinfo.u_company = localStorage.getItem('u_company');
				inportinfo.u_account = localStorage.getItem('u_account');
				inportinfo.mode = this.p_mode;
			}
			if (error == '') {
				return inportinfo;
			} else {
				this.$tool.message(error, 0);
				return '';
			}
		},
		GetImportFee(){
			var that=this;
			var paraminfo = new Object();
			paraminfo = this.checkdata(paraminfo);
			if (paraminfo != '') {
				this.$tool.loading('正在导入', 'orderinport');
				console.log('inportinfo', JSON.stringify(paraminfo));
				this.$apipost.post.GetImportFee({ paraminfo: JSON.stringify(paraminfo) }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if(res.state=='1'){
							that.$refs.exportwin.p_id=res.p_id;
							that.$refs.exportwin.batch=res.list[0].batch;//报价的批次号
							that.$refs.exportwin.SureExport();
							this.$tool.message('报价成功',1);
							that.uploadfileurl = '';
							that.filename ='';
							that.tid = '';
						}else{
							if(res.localfilename!=undefined){
								if(res.localfilename!=''){
									this.$tool.message('报价失败，请查看下载的详情', 0);
									this.$tool.downfile(that,res.localfilename);
								}
							}
						}
					} else {
						this.$tool.message('报价异常，请重试', 0);
					}
				});
			}
		}
	}
}
</script>
<style>
</style>
